import AnalyticsDashboardAppConfig from './dashboards/analytics/AnalyticsDashboardAppConfig';
// import ManageTastesAppConfig from './manageTastes/ManageTastesAppConfig';
import ManageCategoriesAppConfig from './manageCategories/ManageCategoriesAppConfig';
// import ManageRestaurantConfig from './manageRestaurant/ManageRestaurantConfig';
// import ClaimPlaceAppConfig from './ClaimRequests/ClaimRequestsAppConfig';
// import ManageFoodCategoryConfig from './manageFoodCategory/ManageFoodCategoryAppConfig'
// import ManageUsersAppConfig from './ManageUsers/ManageUsersAppConfig';
// import ManageOwnersAppConfig from './ManageOwners/ManageUsersAppConfig';
// import ManageFeaturesAppConfig from './manageFeatures/ManageFeaturesAppConfig';
// import EventsAppConfig from './ManageEvent/EventsAppConfig';
// import OrderAppConfig from './manageOrder/OrderAppConfig';
// import ManagelanguagesAppConfig from './manageLanguages/ManagelanguagesAppConfig';
// import ManageTermsAppConfig from './manageTerms/ManageTermsAppConfig';
// import CustomerClaimPlaceAppConfig from './ManageCustomerClaimReq/ClaimRequestsAppConfig';
// import ManageCustomerRestaurantConfig from './ManageCustomerRestaurant/ManageRestaurantConfig';
// import SuggetionAppConfig from './SuggestionEdit/SuggetionAppConfig';
// import ReportedAppConfig from './Reported/ReportedAppConfig';
// import ManageNewslatterAppConfig from './ManageNewslatter/ManageUsersAppConfig'
// import ManageStaticPageAppConfig from './ManageStaticPage/ManageStaticPageAppConfig'
// import ManageFaqAppConfig from './ManageFaq/ManageFaqAppConfig'

const appsConfigs = [
	AnalyticsDashboardAppConfig,
	// ManageTastesAppConfig,
	ManageCategoriesAppConfig, 
	// ManageRestaurantConfig,
	// ClaimPlaceAppConfig,
	// ManageFoodCategoryConfig,
	// ManageUsersAppConfig,
	// ManageFeaturesAppConfig,
	// ManageOwnersAppConfig,
	// ManagelanguagesAppConfig,
	// ManageTermsAppConfig,
	// EventsAppConfig,
	// OrderAppConfig,
	// CustomerClaimPlaceAppConfig,
	// ManageCustomerRestaurantConfig,
	// SuggetionAppConfig,
	// ReportedAppConfig,
	// ManageNewslatterAppConfig,
	// ManageStaticPageAppConfig,
	// ManageFaqAppConfig
];

export default appsConfigs;
